import { render } from "./SafetyPlan.vue?vue&type=template&id=f0776e9a"
import script from "./SafetyPlan.vue?vue&type=script&lang=js"
export * from "./SafetyPlan.vue?vue&type=script&lang=js"

import "./SafetyPlan.vue?vue&type=style&index=0&id=f0776e9a&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__